import { useCallback, useEffect, useState } from "react";
import { useDropzone } from 'react-dropzone';
import BaseModal from "../baseModal";
import { Alert, Backdrop, CircularProgress, Grid, Snackbar } from "@mui/material";
import TextFieldComponent from "../chimeform/TextFieldComponent";
import { Emoji } from "../emoji/Emojis";
import UploadAttachmentComponent from "../chimeform/UploadAttachmentComponent";
import UploadThumbnailAttachmentComponent from "../chimeform/UploadThumbnailAttachmentComponent";
import { userSession, getUserData, authenticatedUserAddress } from "../../services/auth";
// import CityCoinMinePreview from "../chimeform/CityCoinMinePreview";
// import CityCoinMineButton from "../chimeform/CityCoinMineButton";
import ExtensionOptionsButton from "../chimeform/ExtensionOptionsButton";
import { cityCoins, cryptoCash } from "../../lib/currency";
import { SendMessageCall } from "../../services/chime";
import AttachmentPreview from "../chimeform/AttachmentPreview";
import { save } from "../../services/stacks";
// Stylers
import ConfirmModal from "./ConfirmModal";
import MineValuesSliders from "../chimeform/MineValuesSliders";
import './style.scss';
import { bufferCVFromString } from "@stacks/transactions";
import { Buffer } from 'buffer'
import BnsWarningModal from "./BnsWarningModal";
import { clientNetwork } from "../../lib/constants";
import ExtensionModal from "./ExtensionModal";
import ExhibitAttachmentPreview from "../chimeform/ExhibitAttachmentPreview";
// File Handlers
const fileReader = new FileReader();
const imageHandler = new Image();

const CreateChimeModal = ({ show, setShow, close, exhibitAttachment }) => {
  // Authed user state
  const [authedUser, setAuthedUser] = useState('');
  // ChimeContent state setters
  const [chimeContent, setChimeContent] = useState('');
  const [thumbnailUrl, setThumbnailUrl] = useState({ th_url: '', th_file: null, th_name: '', th_state: false, type: '' });
  const [attachmentUrl, setAttachmentUrl] = useState({ at_url: '', at_file: null, at_name: '', at_state: false, type: '' });
  //Button's state handler
  const [attachmentBtn, setAttachmentBtn] = useState(false);
  const [thumbnailBtn, setThumbnailBtn] = useState(true);
  // const [cancelBtn, setCancelBtn] = useState(false);
  const [chimeBtn, setChimeBtn] = useState(true);
  const [txId, setTxId] = useState('');
  // Loading state 
  const [backdropOpen, setBackdropOpen] = useState(false);

  // Citymine state and handler
  const [selectedMineCity, setSelectedMineCity] = useState(0);
  // function selectMineCityHandler() {
  //   setSelectedMineCity((selectedMineCity + 1) % cityCoins.length);
  // }

  //All State below here handles the Input Mui Textfield
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showBnsWarningModal, setShowBnsWarningModal] = useState(false);
  const [showExtensionModal, setShowExtensionModal] = useState(false);

  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [helperText, setHelperText] = useState('Byte total: 0');
  // Byte counter state
  const [valueByte, setValueByte] = useState(0);
  function handleTextChange(e) {
    const { target: { value } } = e;
    const valueBytes = Buffer.from(value, 'utf-8').byteLength;
    setChimeContent(value);
    setValueByte(valueBytes);
  }
  //Snackbar close handler
  const [openSnackBar, setOpenSnackBar] = useState(false);
  function handleCloseSnackBar() { setOpenSnackBar(false); };

  // Block handler
  const [blocks, setBlocks] = useState(20);
  // Stx input handler
  const [stxInput, setStxInput] = useState(2);
  // Mine strategy handler
  const [strategy, setStrategy] = useState(1);

  // Extras state
  const [extrasValues, setExtrasValues] = useState({});
  // Extension action indicate state
  const [extensionAction, setExtensionAction] = useState('');

  useEffect(() => {
    if (userSession.isUserSignedIn()) {
      //setAuthedUser(getUserData().profile.stxAddress.testnet);
      setAuthedUser(authenticatedUserAddress({ network: clientNetwork }));
      console.log("p2 automagic networking: " + authedUser)

      setValueByte(Buffer.from(chimeContent, 'utf-8').byteLength);
      setHelperText(valueByte > 255 ? `Input is too long (maximum is 255 bytes): ${valueByte}` : `Byte total: ${valueByte}`);
      setShowError(valueByte > 255 ? true : false);
      if ((chimeContent.length > 0 && attachmentUrl.at_state === false && thumbnailUrl.th_state === false) ||
        (chimeContent.length > 0 && attachmentUrl.at_state === true && thumbnailUrl.th_state === true) ||
        (chimeContent.length > 0 && attachmentUrl.at_state === true && attachmentUrl.type === 'image')) {
        setChimeBtn(false);
      } else {
        setChimeBtn(true);
      }
    }
  }, [chimeContent, thumbnailUrl, attachmentUrl, valueByte, thumbnailBtn, attachmentBtn, authedUser])

  // File drop handler
  const onDrop = useCallback((acceptedFiles) => {
    setBackdropOpen(true);
    acceptedFiles.forEach((file) => {
      const { type, name } = file;
      const fileName = `${Date.now()}.${String(name).split('.').pop().toLowerCase()}`;
      console.log({ fileName });
      switch (String(type).split('/')[0]) {
        case "image":
          fileReader.onload = () => {
            const imageSrc = fileReader.result;
            imageHandler.src = imageSrc;
            imageHandler.onload = () => {
              if (imageHandler.width === 1280 && imageHandler.height === 720) {
                fileReader.onload = () => {
                  const content = fileReader.result;
                  save({ fileName, content }, { encrypt: false }).then(({ success, result }) => {
                    if (success && !attachmentUrl.at_state) {
                      setAttachmentUrl({ at_url: result, at_file: content, at_name: fileName, at_state: true, type: String(type).split('/')[0] });
                      setAttachmentBtn(true);
                      setThumbnailBtn(true);
                    } else if (success && attachmentUrl.at_state) {
                      setThumbnailUrl({ th_url: result, th_file: content, th_name: fileName, th_state: true, type: String(type).split('/')[0] });
                      setAttachmentBtn(true);
                      setThumbnailBtn(true);
                    } else {
                      setThumbnailUrl({ th_url: '', th_file: null, th_name: '', th_state: false, type: '' });
                      setAttachmentBtn(false);
                      setThumbnailBtn(true);
                    }
                  })
                }
                fileReader.readAsArrayBuffer(file);
              } else {
                setErrorMsg('Must Be: 1280x720px, .png, & not larger than 20mb');
                setOpenSnackBar(true);
              }
            }
          }
          fileReader.readAsDataURL(file);
          break;
        case "audio":
          fileReader.onload = () => {
            const content = fileReader.result;
            save({ fileName, content }, { encrypt: false }).then(({ success, result }) => {
              if (success) {
                setAttachmentUrl({ at_url: result, at_file: content, at_name: fileName, at_state: true, type: String(type).split('/')[0] });
                setAttachmentBtn(true);
                setThumbnailBtn(false);
              } else {
                setAttachmentUrl({ at_url: '', at_file: null, at_name: '', at_state: false, type: '' });
                setAttachmentBtn(false);
                setThumbnailBtn(true);
              }
            })

          }
          fileReader.readAsArrayBuffer(file);
          break;
        case "video":
          fileReader.onload = () => {
            const content = fileReader.result;
            save({ fileName, content }, { encrypt: false }).then(({ success, result }) => {
              if (success) {
                setAttachmentUrl({ at_url: result, at_file: content, at_name: fileName, at_state: true, type: String(type).split('/')[0] });
                setAttachmentBtn(true);
                setThumbnailBtn(false);
              } else {
                setAttachmentUrl({ at_url: content, at_file: content, at_name: fileName, at_state: true, type: String(type).split('/')[0] });
                setAttachmentBtn(false);
                setThumbnailBtn(true);
              }
            })

          }
          fileReader.readAsArrayBuffer(file);
          break;
        default: break;

      }
    })
    setBackdropOpen(false);
  }, [attachmentUrl])

  const { getInputProps, open } = useDropzone({
    noKeyboard: true, noClick: true, onDrop, maxFiles: 1, maxSize: 20971520,
    accept: attachmentBtn ? "image/png" : "image/jpeg, image/jpg, image/png, image/gif, audio/mp3, audio/mpeg, audio/wav, audio/wave, video/mp4"
  });

  function createChimeModalCloseHandler() {
    setShowConfirmModal(false);
    setChimeContent('');
    setAttachmentUrl({ at_url: '', at_file: null, at_name: '', at_state: false, type: '' });
    setThumbnailUrl({ th_url: '', th_file: null, th_name: '', th_state: false, type: '' });
    setAttachmentBtn(false);
    setThumbnailBtn(false);
    setSelectedMineCity(0);
    close();
  }

  useEffect(() => {
    if (exhibitAttachment?.at_state) {
      setAttachmentUrl(exhibitAttachment);
      setAttachmentBtn(true);
      setThumbnailBtn(false);
    }
  }, [exhibitAttachment])

  return (
    <>
      <BaseModal show={show} setShow={setShow} handleClose={createChimeModalCloseHandler}
      // cancelBtn={cancelBtn}
      >
        <div id="form-container">
          {/* Dropzone Enabler */}
          <input hidden {...getInputProps()} />
          {/* Preview Block */}
          <AttachmentPreview attachmentUrl={attachmentUrl} thumbnailUrl={thumbnailUrl}
            setThumbnailUrl={setThumbnailUrl} setAttachmentUrl={setAttachmentUrl}
            setThumbnailBtn={setThumbnailBtn} setAttachmentBtn={setAttachmentBtn}
          />

          {/* TextField Block */}
          <TextFieldComponent chimeContent={chimeContent} helperText={helperText} error={showError} onChange={handleTextChange}
            setChimeContent={setChimeContent} setShowError={setShowError} setHelperText={setHelperText}
            setValueByte={setValueByte}
          />

          <Grid container item xs={12} direction="row" id="chime-buttons-container">
            {/* Emoji handler */}
            <Emoji setChimeContent={setChimeContent} chimeContent={chimeContent} />

            {/* Attachment upload button handler */}
            <UploadAttachmentComponent btnDisable={attachmentBtn} getInputProps={getInputProps} open={open} setShowBnsWarningModal={setShowBnsWarningModal} />

            {/* Thumbnail upload button handler */}
            <UploadThumbnailAttachmentComponent btnDisable={thumbnailBtn} getInputProps={getInputProps} open={open} setShowBnsWarningModal={setShowBnsWarningModal} />

            {/* Extension Options button handler */}
            <ExtensionOptionsButton setShowExtensionModal={setShowExtensionModal} />

            {/* Citycoin mine button handler */}
            {/* <CityCoinMineButton selectMineCityHandler={selectMineCityHandler} /> */}

            {/* Selected mine citycoin preview button handler */}
            {/* <CityCoinMinePreview selectedMineCity={selectedMineCity} /> */}
          </Grid>

          {(attachmentUrl.at_state && attachmentUrl.type === 'md') && (
            <ExhibitAttachmentPreview attachmentUrl={attachmentUrl} thumbnailUrl={thumbnailUrl} setThumbnailBtn={setThumbnailBtn} setThumbnailUrl={setThumbnailUrl} />
          )}

          {/* Sliders handler */}
          <Grid container item xs={12} direction="row" id="chime-buttons-container">
            <MineValuesSliders selectedMineCity={selectedMineCity} setBlocks={setBlocks} setStxInput={setStxInput} setStrategy={setStrategy} blocks={blocks} stxInput={stxInput} strategy={strategy} />
          </Grid>

          {/* CreateChime button handler */}
          <SendMessageCall id="chime-button" chimeBtn={chimeBtn} close={() => createChimeModalCloseHandler()}
            chimeContent={{ content: chimeContent, extras: extrasValues, attachmentUri: attachmentUrl.at_url, thumbnailUri: thumbnailUrl.th_url }}
            setShowConfirmModal={setShowConfirmModal} setTxId={setTxId}
            blocks={blocks} stxInput={stxInput}
            setOpenSnackBar={setOpenSnackBar} setErrorMsg={setErrorMsg}
          />

        </div>
      </BaseModal>

      {showConfirmModal && <ConfirmModal show={showConfirmModal} setShow={setShowConfirmModal} close={() => createChimeModalCloseHandler()} txId={txId} />}
      {showBnsWarningModal && <BnsWarningModal show={showBnsWarningModal} close={() => setShowBnsWarningModal(false)} />}
      {showExtensionModal && <ExtensionModal
        show={showExtensionModal}
        close={() => setShowExtensionModal(false)}
        filters={{
          'dislike-message': false,
          'favorable-reply-message': false,
          'gift-message': false,
          'like-message': false,
          'send-message': true,
          'unfavorable-reply-message': false
        }}
        extrasValues={extrasValues}
        setExtrasValues={setExtrasValues}
        extensionAction={extensionAction}
        setExtensionAction={setExtensionAction}
        setErrorMsg={setErrorMsg}
        setOpenSnackBar={setOpenSnackBar}
        setOpenConfirmModal={setShowConfirmModal}
        txId={txId}
        setTx_Id={setTxId}
        authorPrincipal={authedUser}
      />}

      {/* Snack bar joint */}
      <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleCloseSnackBar} sx={{ zIndex: '100001' }}>
        <Alert onClose={handleCloseSnackBar} severity="error" sx={{ width: '100%' }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      {backdropOpen && <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>}
    </>

  );
}

export default CreateChimeModal;